// import {InputProps, useInput, useRecordContext, useResourceContext, useTranslate} from 'ra-core';
import HelperText from './shared/HelperText';
import ErrorText from './shared/ErrorText';
import Label from 'components/basic/Label';
import {uploadAdapter} from './ckeditor5/ckeditor-upload-adapter';
import Gallery, {GallerySelectDialog, useGalleryPlugin} from './ckeditor5/gallery-plugin';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import type {EditorConfig} from '@ckeditor/ckeditor5-core';
import {type FileLoader} from '@ckeditor/ckeditor5-upload';
/// plugins
import {ClassicEditor} from '@ckeditor/ckeditor5-editor-classic';
import {Essentials} from '@ckeditor/ckeditor5-essentials';
import {Paragraph} from '@ckeditor/ckeditor5-paragraph';
import {Heading} from '@ckeditor/ckeditor5-heading';
import {List} from '@ckeditor/ckeditor5-list';
import {Bold, Italic} from '@ckeditor/ckeditor5-basic-styles';
import {
  Image,
  ImageCaption,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  ImageUpload,
} from '@ckeditor/ckeditor5-image';
import {LinkImage} from '@ckeditor/ckeditor5-link';
import {MediaEmbed} from '@ckeditor/ckeditor5-media-embed';
import {Alignment} from '@ckeditor/ckeditor5-alignment';
import clsx from 'clsx';
import {InputProps, useInput} from '@/hooks/useInput';
import {useResourceParams} from '@refinedev/core';

export type CKEditorUploadProps = {
  disableImageUpload?: boolean;
  tags?: string[];
  resource?: string;
};

const config: EditorConfig & {[key: string]: any} = {
  plugins: [
    Essentials,
    Paragraph,
    Heading,
    List,
    Bold,
    Italic,
    Image,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    // ImageUpload,
    ImageResize,
    LinkImage,
    // Gallery,
    MediaEmbed,
    Alignment,
  ],
  toolbar: [
    'undo',
    'redo',
    'heading',
    'bold',
    'italic',
    'alignment',
    'numberedList',
    'bulletedList',
    // 'imageUpload',
    'mediaEmbed',
    // 'gallery',
  ],
  image: {
    toolbar: [
      'imageStyle:block',
      'imageStyle:side',
      '|',
      'toggleImageCaption',
      'imageTextAlternative',
      // '|',
      // 'linkImage',
    ],
    insert: {
      // If this setting is omitted, the editor defaults to 'block'.
      // See explanation below.
      type: 'auto',
    },
  },
};

/// ckeditor
const RichTextInput = (
  props: InputProps & CKEditorUploadProps & Partial<React.ComponentProps<'div'>>,
) => {
  const {id: record_id, resource} = useResourceParams(props);
  // const {id: record_id} = record || {};
  const {tags, disableImageUpload = false, className} = props;
  const {
    field: {value, onChange},
    fieldState,
  } = useInput(props);
  // const translate = useTranslate();
  const gallery = useGalleryPlugin();
  const custom_properties = {resource: resource?.name, record_id, tags};
  // if (!resource) return <p>Rich text input doesn't have resource</p>;

  return (
    <div className={clsx('form-control w-full', className)}>
      <Label>{props.label}</Label>
      <HelperText helperText={props.helperText} />
      <ErrorText {...fieldState} />
      <div className="max-h-[500px] overflow-y-auto">
        <CKEditor
          // @ts-expect-error
          config={{...config, gallery}}
          editor={ClassicEditor}
          data={value}
          onReady={editor => {
            // You can store the "editor" and use when it is needed.
            console.log('Editor is ready to use!', editor);
            editor.editing.view.change(writer => {
              const rootElement = editor.editing.view.document.getRoot();
              if (rootElement) writer.setStyle('height', '100%', rootElement);
            });
            // if (!disableImageUpload)
            //   editor.plugins.get('FileRepository').createUploadAdapter = (loader: FileLoader) =>
            //     uploadAdapter(loader, custom_properties);
          }}
          onChange={(event, editor) => {
            // console.log(editor.getData());
            onChange(editor.getData());
          }}
          //   onBlur={(event, editor) => {
          //     console.log('Blur.', editor);
          //   }}
          //   onFocus={(event, editor) => {
          //     console.log('Focus.', editor);
          //   }}
        />
        <GallerySelectDialog gallery={gallery} />
      </div>
    </div>
  );
};

export default RichTextInput;
